/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Select_GrowerInputs */

const vi_care_log_select_grower = /** @type {(inputs: Care_Log_Select_GrowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn hộ trồng chè`)
};

/**

* @param {Care_Log_Select_GrowerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_select_grower = /** @type {((inputs?: Care_Log_Select_GrowerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Select_GrowerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_select_grower(inputs)
});